<!-- =========================================================================================
    File Name: JournalEdit.vue
    Description: Edit Journal
    ----------------------------------------------------------------------------------------
    Item Name: Vaagai Tecknowledge - Easy Admin
    Author: Web Team
    Author URL: http://www.vaagai.org.in/
========================================================================================== -->


<template>
    <div class="px-6 pb-2 pt-6">

        <h4> Edit Price Group details </h4> <br/>        

        <div class="p-6">
                        
            <form @submit.prevent="submitForm">

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span>Price Group Name</span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="PriceGroupName" v-validate="'required'" name="PriceGroupName" />
                        <span class="text-danger text-sm" v-show="errors.has('PriceGroupName')">{{ errors.first('PriceGroupName') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <span> Description </span>
                    </div>
                    <div class="vx-col sm:w-1/2 w-full mb-3">
                        <vs-input class="w-full" v-model="PriceGroupDescription" v-validate="'required'" name="PriceGroupDescription" />
                        <span class="text-danger text-sm" v-show="errors.has('PriceGroupDescription')">{{ errors.first('PriceGroupDescription') }}</span>
                    </div>
                </div>

                <div class="vx-row">
                    <div class="vx-col w-full text-right mb-3">
                        <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                        <vs-button color="warning" type="border" class="mb-2" @click.prevent="closePrompt" > {{ $t("CancelButton") }} </vs-button>
                    </div>
                </div>                

            </form>
        </div>
    </div>
</template>

<script>

import companyConfig from '@/company_config.json'
// import common from '@/views/Common.vue'

export default {
    props: {
        editRecordPrompt: {
            type: Boolean,
            required: true,
        },
        recordIndex: {
            type: Number,
            required: true,
        }        
    },    
    data() {
        return {
            // activePrompt: false,

            PriceGroupId: this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupId,
            PriceGroupName: this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupName,
            PriceGroupDescription: this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupDescription,

        }
    },
    computed: {
    },
    methods: {
        closePrompt() {
            console.log('closePrompt called');
            this.$emit('hideEditRecordPrompt');
        },
        updateRecordDetails() {

            var recordObj = {
                "PriceGroupName" :  this.PriceGroupName, 
                "PriceGroupDescription" :  this.PriceGroupDescription, 
            };

            var server_url=companyConfig.apiURL;
            var record={};
            record.token=this.$session.get('token');
            record.update_url=server_url+'lib/api/party/pricegroup/update';
            record.where={ 'PriceGroupId': this.PriceGroupId };
            record.form=recordObj;
            record.list_url=server_url+'lib/api/party/pricegroup/lists';
            record.list_where={};
            console.log('record='+JSON.stringify(record));
            record.loading=this.$vs.loading;
            record.notify=this.$vs.notify;
            record.http=this.$http;                        
            this.$store.dispatch('partyPriceGroup/updateRecordDetails', record);

            this.closePrompt();
        },
        init() {
            // clear all fileds in todo
            this.PriceGroupId = this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupId,
            this.PriceGroupName = this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupName,
            this.PriceGroupDescription = this.$store.state.partyPriceGroup.dataArray[this.recordIndex].PriceGroupDescription,
            
            this.$parent.editRecordPrompt = false;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.updateRecordDetails();
            })
        }
    },
}
</script>
